import React, { useState } from "react";
import { FlatList, Text, View } from "react-native";
import { connect } from "react-redux";
import { STYLES } from "../assets/styles";

const FashionOptions = ({ itemTypes = [], onChange = () => {} }) => {
  const [selected, setSelected] = useState(0);
  const Item = ({ data, index, selected }) => (
    <Text
      style={{
        textTransform: "capitalize",
        fontSize: STYLES.fontSizes.medium,
        color: "black",
        fontWeight: "bold",
        borderBottomWidth: selected ? 2 : 0,
        padding: 5,
        margin: 5,
      }}
      onPress={() => {
        setSelected(index);
        onChange(data, index);
      }}
    >
      {data}
    </Text>
  );
  return (
    <View>
      <FlatList
        keyExtractor={(_, index) => index + "w"}
        data={itemTypes}
        horizontal
        showsHorizontalScrollIndicator={false}
        renderItem={({ item, index }) => (
          <Item
            data={item}
            key={index + "w"}
            index={index}
            selected={selected === index}
          />
        )}
        extraData={selected}
      />
    </View>
  );
};

const mapStateToProps = (state) => ({
  itemTypes: state.item.itemTypes,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FashionOptions);
